// Small presentation helpers shared by the Payroll Reports tabs.
//
// These lived inside PayrollReports.tsx, which was fine while every tab was
// defined in that one file. The TDS tab is large enough to warrant its own
// module, and importing back from PayrollReports would be circular — so the
// pieces both sides need live here.
import React from "react";

export const inr = (n: number) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export function Notice({
  children,
  error = false,
}: {
  children: React.ReactNode;
  error?: boolean;
}) {
  return (
    <div
      className="gt-card p-5"
      role={error ? "alert" : undefined}
      style={error ? { color: "#991b1b" } : undefined}
    >
      {children}
    </div>
  );
}
